"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpore = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const config_1 = require("../../../config");
const helpers_1 = require("../../../helpers");
const __1 = require("../..");
const cobuild_1 = require("../../../cobuild");
async function createSpore(props) {
    // Env
    const config = props.config ?? (0, config_1.getSporeConfig)();
    const indexer = new lumos_1.Indexer(config.ckbIndexerUrl, config.ckbNodeUrl);
    const capacityMargin = lumos_1.BI.from(props.capacityMargin ?? 1_0000_0000);
    const maxTransactionSize = props.maxTransactionSize ?? config.maxTransactionSize ?? false;
    // TransactionSkeleton
    let txSkeleton = lumos_1.helpers.TransactionSkeleton({
        cellProvider: indexer,
    });
    // If referencing a ClusterAgent, get it from the OutPoint
    let clusterAgentCell;
    if (props.clusterAgentOutPoint) {
        clusterAgentCell = await (0, __1.getClusterAgentByOutPoint)(props.clusterAgentOutPoint, config);
    }
    // Create and inject a new spore cell, also inject cluster if exists
    const injectNewSporeResult = await (0, __1.injectNewSporeOutput)({
        txSkeleton,
        data: props.data,
        toLock: props.toLock,
        fromInfos: props.fromInfos,
        changeAddress: props.changeAddress,
        updateOutput: props.updateOutput,
        clusterAgent: props.clusterAgent,
        cluster: props.cluster,
        mutant: props.mutant,
        clusterAgentCell,
        capacityMargin,
        config,
    });
    txSkeleton = injectNewSporeResult.txSkeleton;
    // Inject needed capacity
    const injectNeededCapacityResult = await (0, helpers_1.injectNeededCapacity)({
        txSkeleton,
        fromInfos: props.fromInfos,
        changeAddress: props.changeAddress,
        config: config.lumos,
    });
    txSkeleton = injectNeededCapacityResult.txSkeleton;
    const injectCapacityAndPayFeeResult = await (0, helpers_1.injectCapacityAndPayFee)({
        txSkeleton,
        fromInfos: props.fromInfos,
        changeAddress: props.changeAddress,
        updateTxSkeletonAfterCollection(_txSkeleton) {
            // Generate and inject SporeID
            _txSkeleton = (0, __1.injectNewSporeIds)({
                outputIndices: [injectNewSporeResult.outputIndex],
                txSkeleton: _txSkeleton,
                config,
            });
            // Inject CobuildProof
            const sporeCell = txSkeleton.get('outputs').get(injectNewSporeResult.outputIndex);
            const sporeScript = (0, config_1.getSporeScript)(config, 'Spore', sporeCell.cellOutput.type);
            if (sporeScript.behaviors?.cobuild) {
                const actionResult = (0, cobuild_1.generateCreateSporeAction)({
                    txSkeleton: _txSkeleton,
                    reference: injectNewSporeResult.reference,
                    outputIndex: injectNewSporeResult.outputIndex,
                });
                const injectCobuildProofResult = (0, cobuild_1.injectCommonCobuildProof)({
                    txSkeleton: _txSkeleton,
                    actions: actionResult.actions,
                });
                _txSkeleton = injectCobuildProofResult.txSkeleton;
            }
            return _txSkeleton;
        },
        config,
    });
    txSkeleton = injectCapacityAndPayFeeResult.txSkeleton;
    // TODO: If creating a clustered spore, validate the transaction
    // Make sure the tx size is in range (if needed)
    if (typeof maxTransactionSize === 'number') {
        (0, helpers_1.assertTransactionSkeletonSize)(txSkeleton, void 0, maxTransactionSize);
    }
    return {
        txSkeleton,
        outputIndex: injectNewSporeResult.outputIndex,
        reference: injectNewSporeResult.reference,
        mutantReference: injectNewSporeResult.mutantReference,
    };
}
exports.createSpore = createSpore;
//# sourceMappingURL=createSpore.js.map